<template>
  <div class="container-fluid foot">
    <div class="row mx-auto my-auto">
      <div class="col-md-6 col-sm-12">
        <div class="foot-l p-4">
          What Wear & When &copy; 2018 All Rights Reserved. <br>Developed by <a :href="'https://medlmobile.com'">MEDL Mobile Enterprises</a>
        </div>
      </div>
      <div class="col-md-4 col-sm-12">
        <div class="row p-4">
          <div class="col-md-6 col-sm-3 foot-r-1">
            <router-link class="foot-link" to="/terms">TERMS AND CONDITIONS</router-link>
          </div>
          <div class="col-md-6 col-sm-3 foot-r-2">
            <router-link class="foot-link" to="/privacy">PRIVACY</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Foot"
  }
</script>

<style scoped>
  .foot{
    /* Rectangle Copy: */
    background: #3E3E3E;
    height: auto;
    font-family: Geneva;
    font-size: 10pt;
    color: #FFFFFF;
    letter-spacing: 0;
    /*padding-top:25px;*/
  }
  .foot-l{
    /* Terms and Conditions: */
    text-align: left;
  }
  .foot a{
    color:white;
  }
  .foot a:hover{
    color:white;
    font-weight: bold;
    text-decoration: none;
  }
  .foot-link{
    font-size: 10pt;
    color:#FFFFFF;
  }

@media only screen and (max-width: 477px) {
  .foot-l{
    text-align: center;
    margin-bottom: -40px;
    font-size: 9pt;
    color:#FFFFFF;
  }
  .foot-r-1{
    font-size: 10pt;
    color:#FFFFFF;
  }
  .foot-r-1 a{
    font-size: 10pt;
    color:#FFFFFF;
  }
  .foot-r-2 a{
    font-size: 10pt;
    color:#FFFFFF;
  }
}
</style>
